import { render, staticRenderFns } from "./currency.vue?vue&type=template&id=2abcd9ae&scoped=true&"
import script from "./currency.vue?vue&type=script&lang=js&"
export * from "./currency.vue?vue&type=script&lang=js&"
import style0 from "./currency.vue?vue&type=style&index=0&id=2abcd9ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abcd9ae",
  null
  
)

export default component.exports